import {useMutation} from '@apollo/react-hooks';

import type {
    ApproveImport2FullMigration as ApproveImport2FullMigrationMutation,
    ApproveImport2FullMigrationVariables as ApproveImport2FullMigrationMutationVariables,
} from 'nutshell-graphql-types';

import APPROVE_MIGRATION from '../mutations/approve-import2-full-migration.graphql';

export function useApproveImport2FullMigration(): (originId: string) => Promise<any> {
    const [approveMigration] = useMutation<
        ApproveImport2FullMigrationMutation,
        ApproveImport2FullMigrationMutationVariables
    >(APPROVE_MIGRATION);

    return (originId: string) => {
        return approveMigration({
            variables: {input: {originId}},
        });
    };
}
